$(function () {
    $('.back-to-top').on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 300);
    });

    function setHeaderHeightVar() {
        var headerHeight = $('.site-header').outerHeight() || 0;
        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    }

    setHeaderHeightVar();
    $(window).on('resize', setHeaderHeightVar);

    var $readingProgressBar = $('#readingProgressBar');

    if ($readingProgressBar.length) {
        var updateReadingProgress = function () {
            var scrollTop = window.scrollY || document.documentElement.scrollTop;
            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
            var progress = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;

            $readingProgressBar.css('width', Math.min(100, Math.max(0, progress)) + '%');
        };

        updateReadingProgress();

        window.addEventListener('scroll', updateReadingProgress, { passive: true });
        window.addEventListener('resize', updateReadingProgress);
    }

    $('.tag-badge-collapse-wrap').each(function () {
        var $wrap = $(this);
        var $pillsBox = $wrap.children().first();
        var $fade = $wrap.find('.tag-filter-fade');
        var $toggle = $wrap.next('.tag-filter-toggle-wrap').find('.tag-filter-toggle');
        var isExpanded = false;
        var collapsedMaxHeight = 150;

        function pillsOverflow() {
            return $pillsBox.length && $pillsBox[0].scrollHeight > collapsedMaxHeight + 4;
        }

        function refreshToggle() {
            if (!pillsOverflow() && !isExpanded) {
                $fade.hide();
                $toggle.hide();

                return;
            }

            $toggle.show().text(isExpanded ? $toggle.data('show-less') : $toggle.data('show-more'));
            $fade.toggle(!isExpanded);
        }

        refreshToggle();

        $toggle.on('click', function () {
            isExpanded = !isExpanded;

            $pillsBox.toggleClass('is-expanded', isExpanded);

            refreshToggle();
        });
    });
});
